/**
 * Whether the Cruz del Sur Pasajero Frecuente loyalty account feature is active.
 * Distinct from SHOW_FREQUENT_PASSENGERS (Core fingerprint passengers).
 * @param {object} features - Whitelabel feature flags.
 * @param {string} brand - Tenant brand slug (e.g. "cds").
 * @returns {boolean}
 */
export default function isCdsFrequentPassengerEnabled(features, brand) {
  if (brand !== 'cds') return false;
  return Boolean(features?.CDS_FREQUENT_PASSENGER_ENABLED);
}
